<template>
  <div class="com-team">
    <div class="header">
      <div class="left box">
        <div class="icon image">
          <img v-hb-img.src="teamLeft.team_icon" />
        </div>
        <div class="name">{{ teamLeft.name }}</div>
      </div>
      <div class="text hel-font">{{ matchData.team.map_name || 'vs' }}</div>
      <div class="right box">
        <div class="name">{{ teamRight.name }}</div>
        <div class="icon image">
          <img v-hb-img.src="teamRight.team_icon" />
        </div>
      </div>
    </div>
    <div class="team-list">
      <div
        class="row"
        :class="[index == 0 ? 'green' : 'red']"
        v-for="(item, index) in teamList"
        :key="index"
      >
        <div
          class="player image"
          v-for="(player, index) in item.player_list"
          :key="index"
        >
          <img v-hb-img.src="player.hero_icon" alt="" />
          <div class="icon image">
            <img v-hb-img.src="player.avatar" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
    matchData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    teamList() {
      return this.matchData.team.team_list || [];
    },
    teamLeft() {
      return this.teamList[0] || {};
    },
    teamRight() {
      return this.teamList[1] || {};
    },
  },
};
</script>

<style lang="less" scoped>
.com-team {
  padding: 8px 10px 10px;
  background: #fafbfc;
  .header {
    position: relative;
    padding-bottom: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #f3f4f5;
      transform: scaleY(0.5);
    }
    .box {
      display: flex;
      align-items: center;
      &.left {
        color: #4a998a;
      }
      &.right {
        color: #b4454e;
      }
      .icon {
        width: 30px;
        height: 30px;
        img {
          object-fit: scale-down;
          border-radius: 3px;
        }
      }
      .name {
        margin: 0 6px;
        font-size: 12px;
        font-weight: 500;
      }
    }
    .text {
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 10px;
      color: #8c9196;
    }
  }
  .team-list {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .row {
      display: flex;
      .player {
        width: 30px;
        height: 30px;
        position: relative;
        border-radius: 3px;
        &:nth-child(n + 2) {
          margin-left: 2px;
        }
        .icon {
          width: 12px;
          height: 12px;
          border-radius: 2px;
          border: 1px solid #fff;
          border-bottom: none;
          border-left: none;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>
